import { LocatorFieldAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';

import Field from '../field/field';

@AwesomeComponent({ type: ComponentType.FORM, api: LocatorFieldAPI })
class LocatorField extends Field {

  static propTypes = {
    ...Field.propTypes,
    hideLabel: Field.propTypes.hideLabel.notEnumerable(),
    validatedOnChange: Field.propTypes.validatedOnChange.notEnumerable(),
    validators: Field.propTypes.validators.notEnumerable(),
  };

  static defaultProps = {
    ...Field.defaultProps,
    hideLabel: true,
  };

}

export default LocatorField;
